import React from 'react'
import {withRouter} from 'react-router-dom'
import {Trans} from 'react-i18next'
import {DeleteOutlined} from '@ant-design/icons'

import BButton from 'components/Form/Fields/BButton'
import Counter from 'components/Cart/Counter'
import TotalPrice from 'modules/Checkout/TotalPrice'
import priceParser from 'utils/priceParser'

let tmpPrice = 4242.42;

const CheckoutItem = () => (
  <div>
    <div>
      <img alt={'name'} src={'http://via.placeholder.com/50x50'}/>
      <div>
        <span><b>1x</b> Hamilton Perfection Roller Hamilton Perfection Roller Hamilton Perfection Roller</span>
        <span>Category <b>Building material</b></span>
      </div>
    </div>

    <div>
      <div>
        <button><DeleteOutlined/></button>
      </div>

      <div>
        <Counter amount={1} setAmount={_ => undefined}/> <b>{priceParser(tmpPrice)}</b>
      </div>
    </div>
  </div>
)

const CheckoutShop = ({t}) => (
  <div>
    <div className='checkout1-shopHead'>
      <img alt={'shop name'} src={'http://via.placeholder.com/100x40'}/>
      <h4>Shop name</h4>
    </div>

    <div className='checkout1-shopItems'>
      <CheckoutItem/>
      <CheckoutItem/>
      <CheckoutItem/>

      <div>
        <div>
          <img alt={t('Delivery time')} src={'http://via.placeholder.com/50x50'}/>
          <div>
            <span>{t('Shipping')}</span>
            <span>3 - 4 days</span>
          </div>
        </div>

        <div>
          <div><b>{priceParser(tmpPrice)}</b></div>
        </div>
      </div>
    </div>
  </div>
)

const Checkout1 = ({t, next, cart, history}) => (
  <div id='checkout1'>
    <h1>{t('Products summary')}</h1>

    <div>
      <div className='notice checkout-buildiroTip'>
        <div>
          <h6>{t('BUILDIRO TIP! Save money on shipping')}</h6>

          <p>
            <Trans i18nKey='checkout-buildiroTip'>
              <b/>
              {{price: priceParser(tmpPrice)}}
            </Trans>
          </p>

          <ul>
            <li>Buy <b>Hamilton Perfection Roller</b>… from <b>Travis Perkins</b> or <b>Home Depot</b></li>
          </ul>
        </div>
        <div>
          <BButton green>{t('SHOW CHANGES')}</BButton>
        </div>
      </div>

      <div className='checkout1-shops'>
        <CheckoutShop t={t}/>
        <CheckoutShop t={t}/>
        <CheckoutShop t={t}/>
      </div>

      <div className='checkout1-total'>
        <TotalPrice t={t}/>

        <div>code</div>
      </div>

      <BButton ghost onClick={_ => history.goBack()}>{t('back to shopping')}</BButton>
      <BButton yellow onClick={next}>{t('continue to')} <b>{t('step 2')}</b></BButton>
    </div>
  </div>
)

export default withRouter(Checkout1)
